import api from '@shared/services/api';
import { t } from 'i18next';

export const userGroupsService = {
    getGroups: async ({ searchQuery, pageNumber = 0, pageSize = 10, sortBy = 'name', sortDir = 'asc' }) => {
        try {
            const params = {
                page: pageNumber,
                size: pageSize,
                sortBy: sortBy || 'name',
                sortOrder: sortDir,
                ...(searchQuery?.name && { name: searchQuery.name }),
                ...(searchQuery?.ldapGroup && { ldapGroupId: searchQuery.ldapGroup })
            };

            const response = await api.get('/user-groups', { params });
        
            const { content, page } = response.data;
            
            if (!content || !Array.isArray(content)) {
                console.error('Invalid response - no content:', response);
                throw new Error(t('common.dataNotFound'));
            }

            // Map administrative to isAdministrative for compatibility with the table component
            const mappedContent = content.map(item => ({
                ...item,
                isAdministrative: item.administrative !== undefined ? item.administrative : item.isAdministrative
            }));

            // Handle pagination - use page object if available, otherwise calculate from content
            const totalElements = page?.totalElements ?? content.length;
            const totalPages = page?.totalPages ?? Math.ceil(totalElements / pageSize);
            const currentPageNumber = page?.pageable?.pageNumber ?? pageNumber;

            return {
                content: mappedContent,
                totalPages,
                totalElements,
                pageNumber: currentPageNumber,
                page // Include page object for useFetchData compatibility
            };
        } catch (error) {
            console.error('Error fetching groups:', error);
            throw error;
        }
    },

    getGroupById: async (groupId) => {
        try {
            const response = await api.get(`/user-groups/${groupId}`);

            const group = response.data;

            return {
                name: group.name || '',
                ldapGroupId: group.ldapGroupId || '',
                specRights: group.specRights || []
            };


        } catch (error) {
            console.error('Error fetching user: group', error);
            throw error;
        }
    },

    deleteGroup: async (id) => {
        try {
            const response = await api.delete(`/user-groups/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting group:', error);
            throw error;
        }
    },

    createGroup: async (groupData) => {
        try {
            const response = await api.post('/user-groups', groupData);
            return response.data;
        } catch (error) {
            console.error('Error creating group:', error);
            throw error;
        }
    },


    updateGroup: async (id, groupData) => {
        try {
            const requestBody = {
                name: groupData.name,
                ldapGroupId: groupData.ldapGroupId || '',
                isAdministrative: groupData.is_administrative || false,
                specRights: groupData.specRights || []
            };
            const response = await api.put(`/user-groups/${id}`, requestBody);
            return response.data;
        } catch (error) {
            console.error('Error updating group:', error);
            throw error;
        }
    },
    allUserGroups: async () => {
        try {
            const response = await api.get('/user-groups/list');
            return response.data;
        } catch (error) {
            console.error('Error fetching all user groups:', error);
            throw error;

        };
    },
    getMenus: async () => {
        try {
            const response = await api.get('/menus');
            return response.data;
        } catch (error) {
            console.error('Error fetching menu:', error);
            throw error;
        }
    },
    getUsersByGroup: async (groupId) => {
        try {
            const response = await api.get(`/users/group/${groupId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching users by group:', error);
            throw error;
        }
    },
    detachUsers: async (groupId, userIds) => {
        try {
            const response = await api.post(`/user-groups/dettach-user/${groupId}`, userIds);
            return response.data;
        } catch (error) {
            console.error('Error detaching users:', error);
            throw error;
        }
    },
    attachUsers: async (groupId, userIds) => {
        try {
            const response = await api.post(`user-groups/attach-user/${groupId}`, userIds);
            return response.data;
        } catch (error) {
            console.error('Error attaching users:', error);
            throw error;
        }
    }
}